import type { AutoRotateItem, KrpPlayer } from '@types';
import { MainPlayer } from '@stores/krpPlayerStores';

type Params = Partial<
  Pick<AutoRotateItem, 'hlookat' | 'vlookat' | 'fov' | 'duration'>
> & {
  nonblocking?: true;
};
type CB = Parameters<KrpPlayer['lookTo']>[1];

export function rotateTo(data: Params, onComplete?: CB) {
  const player = MainPlayer.get();
  if (!player) return;
  player.lookTo(data, onComplete);
}

export function rotateToPromise(data: Params): Promise<{ isDone: boolean }> {
  return new Promise((resolve, reject) => {
    const player = MainPlayer.get();
    if (!player) {
      reject(new Error('player is not ready'));
    } else {
      player.lookTo(data, (bool) => {
        resolve({ isDone: bool });
      });
    }
  });
}
